import { render } from "./CardItem.vue?vue&type=template&id=0f0a168b&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=0f0a168b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0a168b"]])

export default __exports__